import { VideoFilmIcon } from '@vlabs/icons';
import { useTranslation } from 'react-i18next';

export function DefaultCaption(): React.ReactNode {
  const { t } = useTranslation();
  const SUPPORTED_TYPES_FOR_CAPTION = ['avi', 'mp4', 'mov', 'mkv', 'flv'];
  const MAX_SIZE_IN_GB = 2;

  return (
    <div className="FileDropzone__Caption">
      <VideoFilmIcon />

      <span className="FileDropzone__CaptionTitle">
        {t('shared:перетащите файл или нажмите')}
      </span>

      <span className="FileDropzone__CaptionDescription">
        {t(
          'checks:video check form.dropzone.supported types',
          { supportedTypes: SUPPORTED_TYPES_FOR_CAPTION.join(', ') },
        )}
      </span>
      <span className="FileDropzone__CaptionDescription">
        {t(
          'checks:video check form.dropzone.max size',
          { maxSize: MAX_SIZE_IN_GB.toString() },
        )}
      </span>
    </div>
  );
}
